import { apiRequest } from "@smp/api";
import {
  Await,
  REACT_APP__POLOTNO_API_KEY,
  REACT_APP__URL_STORAGE_STATIC,
} from "@smp/utils";
import { API } from "polotno/utils/api";
import { useQuery, UseQueryOptions } from "react-query";

type ApiPolotnoTextTemplatesResponse = {
  hits: number;
  items: Array<{ json: string; preview: string }>;
};

const KEY_POLOTNO_TEXT_TEMPLATES = "polotno.text_templates";

export const useQueryPolotnoTextTemplates = (
  options?: Omit<
    UseQueryOptions<Await<ApiPolotnoTextTemplatesResponse>>,
    "queryKey" | "queryFn"
  >,
) =>
  useQuery<Await<ApiPolotnoTextTemplatesResponse>>(
    KEY_POLOTNO_TEXT_TEMPLATES,
    () =>
      Promise.all([
        apiRequest<ApiPolotnoTextTemplatesResponse>({
          endpoint: API + "/get-text-templates",
          method: "GET",
          query: {
            KEY: REACT_APP__POLOTNO_API_KEY,
          },
        }),
        apiRequest<
          Array<{
            template_url: string;
            preview_url: string;
          }>
        >({
          endpoint:
            REACT_APP__URL_STORAGE_STATIC +
            "/polotno/text-templates/index.json?t=" +
            Date.now(),
          method: "GET",
        }),
      ]).then(([resp1, resp2]) => ({
        hits: resp1.hits + resp2.length,
        items: [
          ...resp2.map(({ template_url, preview_url }) => ({
            json: template_url,
            preview: preview_url,
          })),
          ...resp1.items,
        ],
      })),
    options,
  );

useQueryPolotnoTextTemplates.KEY = KEY_POLOTNO_TEXT_TEMPLATES;
